import type {ReactElement} from 'react'
// Components
import SponsorDisplay from '../sponsor-display'
// Utils
import {calculateSponsorshipAdPoolByBallot} from '../../utils/ballot-calculators'
// Types
import type {Ballot} from '../../types/ballot'

interface SponsorBlockProps {
  ballot: Ballot
}

const SponsorBlock = ({ballot}: SponsorBlockProps): ReactElement | null => {
  const sponsorshipAds = calculateSponsorshipAdPoolByBallot(ballot) || []

  if (sponsorshipAds.length <= 0) return null

  return (
    <SponsorDisplay
      ballotId={ballot._id}
      sponsorshipAds={sponsorshipAds}
      styleModifiers={['--ad-text-is-above']}
    />
  )
}

export default SponsorBlock
